// import React, {Suspense, useEffect, useState} from "react";
import React from "react";
import Typed from "typed.js";
import { useRef, useEffect } from "react";
import { usePresence } from "framer-motion";
import { gsap } from "gsap";

const FirstSection = (props) => {
  // ---------to use typed.js---------------

  // Create reference to store the DOM element containing the animation
  const el = React.useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        " Web Developer.",
        "Mechanical Engineer.",
        "Web3 &amp; Blockchain developer.",
      ],
      typeSpeed: 60,
      loop: true, // Enable continuous looping
      loopCount: Infinity, // Set the number of loops (Infinity for infinite looping)
      showCursor: false, // Disable the typing cursor
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);

  // ------------------for switch-button--------------------

  const ref = useRef(null);
  const [isPresent, safeToRemove] = usePresence();
  useEffect(() => {
    if (!isPresent) {
      gsap.to(ref.current, {
        opacity: 0,
        onComplete: () => safeToRemove?.(),
      });
    }
  }, [isPresent, safeToRemove]);

  //-------------------for my github button----------------------------------

  const githubUrl = "https://github.com/mananc12";
  const resumeUrl =
    "https://drive.google.com/file/d/15Ghllovg_gwkWteSsfrh586gqeCFepKB/view?usp=drive_link";

  const ExternalLink = ({ url, children }) => {
    const handleClick = () => {
      window.open(url, "_blank");
    };

    return (
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        {children}
      </div>
    );
  };

  return (
    <div
      className="first-section"
      id="home"
      ref={ref}
      style={{ opacity: props.opacity }}
    >
      <img className={`bulb ${props.style}`} src="images/bulb.png" alt="bulb" />
      <div className="box-background"></div>
      <div className="box-vertical">
        <div className="circle"></div>
      </div>
      <div className="left-section">
        <div className="firstText slide-in-x">
          Hi, I'm
          <span className="purple slide-in-y"> Manan </span>
        </div>
        <div className="secondText slide-in-y">
          and, I am a passionate
          <div className="thirdText slide-in-x">
            {" "}
            <span ref={el} id="element" />{" "}
          </div>
        </div>
        <div className="both-buttons">
          <button className="btn">
            <ExternalLink url={resumeUrl}>
              <p>Download Resume </p>
            </ExternalLink>
          </button>

          <button className="btn">
            <ExternalLink url={githubUrl}>
              <p>Visit My GitHub </p>
            </ExternalLink>
          </button>
        </div>
      </div>
      <div className="right-section">
        <div className="box-inner">
          <div className="image-circle slide-in-y" />
          <img className="slide-in-x" src="images/meta3.png" alt="3d-pic" />
        </div>
      </div>
    </div>
  );
};

export default FirstSection;
